import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propShape } from '../../../../../../../helpers/custom-prop-types';
const ShareTableRowOpenTooltipRow = (props) => {
    const { member: { email, firstName, lastName }, } = props;
    return (_jsxs(_Fragment, { children: [lastName && firstName && (_jsxs(_Fragment, { children: [_jsx("div", { children: `${lastName} ${firstName}` }), _jsx("br", {})] })), _jsx("div", { children: email })] }));
};
ShareTableRowOpenTooltipRow.propTypes = {
    member: propShape().isRequired,
};
export default ShareTableRowOpenTooltipRow;
